import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-folder-edit-mail',
	templateUrl: './folder-edit-mail.component.html',
	styleUrls: ['./folder-edit-mail.component.scss']
})
export class FolderEditMailComponent extends DialogPage implements OnInit {
	// Form data.
	folderEditMailForm = new FormGroup({
		emailSubjectControl: new FormControl(),
		emailIntroControl: new FormControl(),
		emailLinkControl: new FormControl(),
		emailInfoBillControl: new FormControl(),
		emailInfoAnswerControl: new FormControl(),
		emailNotaControl: new FormControl(),
		emailLinkValidControl: new FormControl(),
		emailMoreInfoControl: new FormControl(),
		emailSignatureControl: new FormControl(),
		emailSendToUserControl: new FormControl(),
	});

	// Extra data.
	public folderId: string = "";
	public folderName: string = "";
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Enregistrer";
		this.enableAction = true;
	}

	ngOnInit(): void {
		this.put("/api/folder-mail-details", {id: this.folderId},
			(response:any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "NOT_FOUND":
							this.alertLine.alertDangerMessage = "Impossible de récupérer la liste des dossiers. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					var folderDetail = response.RES;

					this.folderEditMailForm.controls["emailSubjectControl"].setValue(folderDetail["mailSubject"]);
					this.folderEditMailForm.controls["emailIntroControl"].setValue(folderDetail["mailIntroduction"]);
					this.folderEditMailForm.controls["emailLinkControl"].setValue(folderDetail["mailLink"]);
					this.folderEditMailForm.controls["emailInfoBillControl"].setValue(folderDetail["mailBill"]);
					this.folderEditMailForm.controls["emailInfoAnswerControl"].setValue(folderDetail["mailResponse"]);
					this.folderEditMailForm.controls["emailNotaControl"].setValue(folderDetail["mailNota"]);
					this.folderEditMailForm.controls["emailLinkValidControl"].setValue(folderDetail["mailLinkValid"]);
					this.folderEditMailForm.controls["emailMoreInfoControl"].setValue(folderDetail["mailMoreInfo"]);
					this.folderEditMailForm.controls["emailSignatureControl"].setValue(folderDetail["mailSignature"]);
					this.folderEditMailForm.controls["emailSendToUserControl"].setValue(folderDetail["mailGetACopy"]);
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);
	}

	public setModalOptions(data:any):void {
		this.folderId = data["id"];
		this.folderName = data["name"];
	}

	public testMail(): void {
		var mailData = {
			"folderid": this.folderId,
			"SUBJECT":this.folderEditMailForm.controls["emailSubjectControl"].value,
			"INTRODUCTION":this.folderEditMailForm.controls["emailIntroControl"].value,
			"LINK":this.folderEditMailForm.controls["emailLinkControl"].value,
			"INFO_BILL":this.folderEditMailForm.controls["emailInfoBillControl"].value,
			"INFO_ANSWER":this.folderEditMailForm.controls["emailInfoAnswerControl"].value,
			"NOTA":this.folderEditMailForm.controls["emailNotaControl"].value,
			"LINK_VALID":this.folderEditMailForm.controls["emailLinkValidControl"].value,
			"MORE_INFO":this.folderEditMailForm.controls["emailMoreInfoControl"].value,
			"SIGNATURE":this.folderEditMailForm.controls["emailSignatureControl"].value,
			"mode": "TEST"
		};
		this.put("/api/folder-test-creation-mail", mailData,
			(response:any) => {
				alert("Votre email de test est envoyé. Le sujet est précédé par '[TEST]'.");
			},
			(err:any) => {
				alert("Erreur d'envoi ("+err+"). Contactez votre administrateur.");
			}
		);
	}

	public save(): void {
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			id:this.folderId,
			mailSubject:this.folderEditMailForm.controls["emailSubjectControl"].value,
			mailIntroduction:this.folderEditMailForm.controls["emailIntroControl"].value,
			mailLink:this.folderEditMailForm.controls["emailLinkControl"].value,
			mailBill:this.folderEditMailForm.controls["emailInfoBillControl"].value,
			mailResponse:this.folderEditMailForm.controls["emailInfoAnswerControl"].value,
			mailNota:this.folderEditMailForm.controls["emailNotaControl"].value,
			mailLinkValid:this.folderEditMailForm.controls["emailLinkValidControl"].value,
			mailMoreInfo:this.folderEditMailForm.controls["emailMoreInfoControl"].value,
			mailSignature:this.folderEditMailForm.controls["emailSignatureControl"].value,
			mailGetACopy:this.folderEditMailForm.controls["emailSendToUserControl"].value
		};

		this.put("/api/folder-mail-edit", newData,
			(response:any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					var modifiedFolder = {
					};
					this.modalInstance.dismiss(modifiedFolder);
				}
			},
			(err:any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
